import { render, staticRenderFns } from "./tagsBox.vue?vue&type=template&id=37e368de&scoped=true&"
import script from "./tagsBox.vue?vue&type=script&lang=js&"
export * from "./tagsBox.vue?vue&type=script&lang=js&"
import style0 from "./tagsBox.vue?vue&type=style&index=0&id=37e368de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e368de",
  null
  
)

export default component.exports